import { CircularProgress, Tooltip } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import { PropTypes } from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import { TRANSLATION_TARGET_STATUS } from '@/common/utils/translationJobUtils';
import OverflowFileName from './OverflowFileName';

const STATUS_LABEL_KEY = {
    [TRANSLATION_TARGET_STATUS.PENDING]: 'LABEL-TRANSLATION-STATUS-RUNNING',
    [TRANSLATION_TARGET_STATUS.RUNNING]: 'LABEL-TRANSLATION-STATUS-RUNNING',
    [TRANSLATION_TARGET_STATUS.SUCCEEDED]: 'LABEL-TRANSLATION-STATUS-SUCCEEDED',
    [TRANSLATION_TARGET_STATUS.FAILED]: 'LABEL-TRANSLATION-STATUS-FAILED'
};

const renderStatusIcon = status => {
    switch (status) {
        case TRANSLATION_TARGET_STATUS.SUCCEEDED:
            return <CheckIcon size={16} className="file-translation-status-icon file-translation-status-icon-success" />;
        case TRANSLATION_TARGET_STATUS.FAILED:
            return <img src='/assets/image/status-error.svg' alt='status-error' />;
        default:
            return (
                <CircularProgress
                    size={16}
                    thickness={5}
                    className="file-translation-status-icon file-translation-status-icon-running"
                />
            );
    }
};

/**
 * The 翻訳状況 section. Only a finished translation is clickable; a running one offers no stop
 * action and a failed one shows the same state whatever the cause.
 */
function TranslationStatusList({ rows, onOpenFile }) {
    return (
        <div className="file-translation-status">
            <div className="file-translation-label">{trI18n('LABEL-TRANSLATION-STATUS-SECTION')}</div>
            <div class="file-translation-status-list-wrapper">
                <div className="file-translation-status-list">
                    {rows.map(row => {
                        const isDone = row.status === TRANSLATION_TARGET_STATUS.SUCCEEDED;

                        return (
                            <div className="file-translation-status-row" key={row.lang}>
                                <Tooltip title={trI18n(STATUS_LABEL_KEY[row.status] || STATUS_LABEL_KEY.RUNNING)} placement="top" arrow>
                                    <span className="file-translation-status-icon-wrap">{renderStatusIcon(row.status)}</span>
                                </Tooltip>
                                <OverflowFileName
                                    fileName={row.fileName}
                                    className={`file-translation-status-name${isDone ? ' file-translation-status-name-link' : ''}`}
                                    onClick={isDone ? () => onOpenFile(row) : null}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

TranslationStatusList.propTypes = {
    rows: PropTypes.array.isRequired,
    onOpenFile: PropTypes.func.isRequired
};

export default TranslationStatusList;
